/**
 * Lazy HTTP log transport — resolves system-api host on each send
 * (Global Config may not be ready at module bootstrap). Request 0348.
 */

import {
  createHttpLogTransport,
  LogTransportError,
  type LogTransport,
} from '@rammetec/core'
import { authService } from '@/services/authService'
import { systemApiBaseUrl } from '@/services/systemApiClient'

export function createConsoleLogHttpTransport(): LogTransport {
  let cachedUrl: string | null = null
  let cached: LogTransport | null = null

  function resolveInner(): LogTransport {
    let url: string
    try {
      url = `${systemApiBaseUrl('/log/v1')}/ingest`
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err)
      throw new LogTransportError(message, false)
    }
    if (!cached || cachedUrl !== url) {
      cachedUrl = url
      cached = createHttpLogTransport({
        url,
        getToken: () => authService.getIdToken(),
      })
    }
    return cached
  }

  return {
    async send(records, opts) {
      return resolveInner().send(records, opts)
    },
  }
}
